import React, { CSSProperties, FC } from "react";

const PageHeader: FC<{
  text: string | React.ReactNode;
  className?: string;
  style?: CSSProperties;
  headerClass?: string;
}> = ({ text, className, style, headerClass }) => {
  return (
    <div
      className={`kit__utils__heading ${className ?? ""}`}
      style={{ padding: 0, margin: 0, ...style }}
    >
      <h5 className={headerClass ?? ""}>
        <span className="mr-3">{text}</span>
      </h5>
    </div>
  );
};

export default PageHeader;
